"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const location_component_1 = __importDefault(require("./location-component"));
const LocationComponents = ({ cityLetter, cities, holidays, availability, availabilityErr }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: styles_module_scss_1.default.groupingByCityLetter }, { children: [(0, jsx_runtime_1.jsx)("h3", Object.assign({ id: `${cityLetter}-${t("locations")}` }, { children: cityLetter })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `${styles_module_scss_1.default.locationsListHolder} ontario-margin-top-2` }, { children: Object.entries(cities)
                    .sort((a, b) => a[0].localeCompare(b[0]))
                    .map(([city, locations]) => {
                    return (0, jsx_runtime_1.jsx)(location_component_1.default, { city: city, locations: locations, holidays: holidays, availability: availability, availabilityErr: availabilityErr });
                }) }))] }), cityLetter));
};
exports.default = LocationComponents;
